import React from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaPhone } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <h3>XAVIER & XAVIER</h3>
            <p className="footer-text">Chartered Accountants</p>
            <p>Empowering businesses since 1979</p>
          </div>
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-services">
            <h4>Our Services</h4>
            <ul>
              <li>Automation Solutions</li>
              <li>IT Audit & Security</li>
              <li>Accounting Services</li>
              <li>Data Analytics & BI</li>
              <li>Audit & Assurance</li>
              <li>Tax Advisory</li>
            </ul>
          </div>
          <div className="footer-contact">
            <h4>Contact</h4>
            <p><FaEnvelope /> <a href="mailto:contact@xavnxav.com">contact@xavnxav.com</a></p>
            <p><FaPhone /> <a href="tel:+9104612322137">+91 0461 2322137</a></p>
            <p><FaPhone /> <a href="tel:+9104445500861">+91 044 4550 0861</a></p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Xavier & Xavier Chartered Accountants. All rights reserved.</p>
          <p>Powered by <a href="https://esoninfotech.com/" target="_blank" rel="noopener noreferrer">Eson Infotech</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
